module.exports = __webpack_public_path__ + "assets/img/DS-master (10).843149a1.jpg";